import { render, staticRenderFns } from "./GraficoDonutReport.vue?vue&type=template&id=b9a0404e&"
import script from "./GraficoDonutReport.vue?vue&type=script&lang=js&"
export * from "./GraficoDonutReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports